var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5656 19.2313H2.47393C1.34873 19.2313 0.428101 18.3107 0.428101 17.1855V2.86468C0.428101 1.73947 1.34873 0.818848 2.47393 0.818848H6.5656C7.69081 0.818848 8.61143 1.73947 8.61143 2.86468V17.1855C8.61143 18.3107 7.69081 19.2313 6.5656 19.2313ZM12.7031 19.2313H16.7948C17.92 19.2313 18.8406 18.3107 18.8406 17.1855V12.0709C18.8406 10.9457 17.92 10.0251 16.7948 10.0251H12.7031C11.5779 10.0251 10.6573 10.9457 10.6573 12.0709V17.1855C10.6573 18.3107 11.5779 19.2313 12.7031 19.2313ZM18.8406 5.93343V2.86468C18.8406 1.73947 17.92 0.818848 16.7948 0.818848H12.7031C11.5779 0.818848 10.6573 1.73947 10.6573 2.86468V5.93343C10.6573 7.05864 11.5779 7.97926 12.7031 7.97926H16.7948C17.92 7.97926 18.8406 7.05864 18.8406 5.93343Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.fa5d1e73f0aed00d8faa38c254437f80.svg";
export { ForwardRef as ReactComponent };